import { render, staticRenderFns } from "./StudentsResearches.vue?vue&type=template&id=10817797&"
import script from "./StudentsResearches.vue?vue&type=script&lang=js&"
export * from "./StudentsResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports